import ScrollLTR from "../../../../../lms-shared/UI/ScrollLTR"
import classes from './ProblematicList.module.css'
import warnIcon from '../../../../../../assests/learning-tracking/teams/warn.png'
import { useSelector } from "react-redux";

const ProblematicList = ({ list, complete, lessonMode }) => {

    const { texts } = useSelector(state => state.translate);

    return (
        <div>
            <div className={classes.LessonsList}>
                <ScrollLTR>
                    <div className={classes.LessonsListContainer}>
                        {list &&
                            list.map((item, index) => (
                                <div className={classes.LessonItem} key={index}>
                                    <div>{item.name}</div>
                                </div>
                            ))}
                    </div>
                </ScrollLTR>
            </div>
            <div className={classes.Apply} onClick={() => complete(list[0]?.id)}> {lessonMode ? texts.ok : texts.goToLessonDistribution}</div>
        </div>
    )


}
export default ProblematicList